import { FormControl, InputLabel, Select } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const USelect = ({
  name,
  label,
  control,
  defaultValue,
  children,
  fullWidth,
  rules,
  required,
  onChange,
}: {
  name: any;
  label: any;
  control?: any;
  defaultValue?: any;
  fullWidth?: any;
  children: any;
  rules?: any;
  required?: any;
  onChange?: any;
}) => {
  const formContext = useFormContext();
  const _control = control || formContext.control;
  return (
    <Controller
      name={name}
      control={_control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field }) => {
        return (
          <FormControl fullWidth={fullWidth}>
            <InputLabel id={`${name}-label`}>{label}</InputLabel>
            <Select
              required={required}
              labelId={`${name}-label`}
              label={label}
              {...field}
              onChange={(evt) => {
                if (onChange) onChange(evt);
                field.onChange(evt);
              }}
            >
              {children}
            </Select>
          </FormControl>
        );
      }}
    ></Controller>
  );
};

export default USelect;
